import settingLinkTemplate from '../templates/settingLink.hbs';
import $ from 'jquery';
$.fn.sdaSettingLink = function(data) {
    const that = this;

    data = data || {};
    $.extend(data, that.data());

    that.html(settingLinkTemplate(data))
        .scrubDataHTML()
        .attachMethod('setTitle', function(title) {
            that.find('.setting-link-title').text(title);

            return that;
        })
        .attachMethod('setInfo', function(state) {
            that.find('.state-info').html(state);

            return that;
        })
        .attachMethod('disable', function() {
            that.attr('disabled', '');
        })
        .attachMethod('enable', function() {
            that.removeAttr('disabled');
        });

    if (data.panelLinkId) {
        that.on('click', function() {
            $(data.panelLinkId).open();
        });
    }

    return that;
};
